import React from 'react'
import { IssueWarningModal } from 'components/canary/issue_tracking/IssueWarningModal'

interface ArchiveIssueWarningProps {
  archiving?: boolean
  error?: string | null
  onArchive: () => void
  onCancel: () => void
}

export const ArchiveIssueWarning: React.FC<ArchiveIssueWarningProps> = ({
  archiving = false,
  error = null,
  onArchive,
  onCancel
}) => (
  <IssueWarningModal
    testId='archive-issue-warning'
    title='Archive Issue'
    titleId='canary-issue-modal-archive-warning-title'
    error={error}
    messageWrapperClassName='canary-issue-modal__archive-warning-message-wrapper'
    onCancel={onCancel}
    actions={(
      <>
        <button
          type='button'
          className='canary-issue-modal__leave-warning-cancel'
          disabled={archiving}
          onClick={onCancel}
        >
          Cancel
        </button>
        <button
          type='button'
          className='canary-issue-modal__leave-warning-leave'
          disabled={archiving}
          onClick={onArchive}
        >
          {archiving ? 'Archiving...' : 'Archive'}
        </button>
      </>
    )}
  >
    <div className='canary-issue-modal__leave-warning-message canary-issue-modal__archive-warning-message'>
      <p>
        Are you sure you want to Archive this issue?<br />
        Any notes will be lost and there will be no record of this issue being tracked.
      </p>
      <p>
        To retain that information, Resolve the issue instead.
      </p>
    </div>
  </IssueWarningModal>
)
